export class DtoPeriodo {
    ID_Periodo: number = 0;
    Codigo: string = '';
    FechaInicio: Date = new Date();
    FechaFin: Date = new Date();
    FechaMaxima: Date = new Date();
    Mes: number = 0;
    Anio: number = 0;
}